<template>
  <div class="field" style="margin-bottom: 1rem;">
    <router-link
      :to="{ name: `${titleCase(itemType)}Create` }"
      tag="div"
      class="ui primary button">
      <i class="plus icon"/>
      {{ $t(`newItemButton.${itemType}`) }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'NewItemButton',
  props: {
    itemType: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
